import React, { useState } from 'react';
import type { PostClientSendOtpSmsResponse } from '@lt/api/dist/methods/client/types';
import { i18n, useTranslation } from '@lt/localization';
import styles from './sendSmsCodeAgainForm.module.css';
import type { GetNewCodeConfig } from '../../types';

import { Title } from '../Title';
import { Description } from '../Description';
import { Content } from '../Content';
import { ButtonWithLoader } from '../ButtonWithLoader/ButtonWithLoader';
import { ActionItem } from '../ActionItem';

interface Props {
  phone: string;
  getNewCodeOnSuccess(): void;
  backToStartHandler(): void;
  onSubmit: (
    config: GetNewCodeConfig,
  ) => Promise<PostClientSendOtpSmsResponse | void>;
  isAuthProcess: boolean;
  clientId?: number;
  description?: string;
}

const defaultDescription = i18n.t('checkout.sendCode.sms.defaultDescription');

export const SendSmsCodeAgainForm: React.FC<Props> = ({
  phone,
  onSubmit,
  getNewCodeOnSuccess,
  backToStartHandler,
  isAuthProcess,
  clientId,
  description = defaultDescription,
}) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getNewCode = async () => {
    setIsSubmitting(true);

    await onSubmit({
      phone,
      event: !isAuthProcess ? 'sign_up' : 'sign_in',
      ...(clientId && { client_id: clientId }),
      onSuccess: getNewCodeOnSuccess,
    });

    setIsSubmitting(false);
  };

  return (
    <div className={styles.container}>
      <Title>{t('checkout.sendCode.sms.title')}</Title>
      <Description>{description}</Description>
      <Content className={styles.content}>
        <ButtonWithLoader
          primary
          isLoading={isSubmitting}
          disabled={isSubmitting}
          width="100%"
          onClick={getNewCode}
        >
          {t('checkout.sendCode.sms.button')}
        </ButtonWithLoader>
        <ActionItem className={styles.actionItem} onClick={backToStartHandler}>
          {t('checkout.sendCode.sms.return')}
        </ActionItem>
      </Content>
    </div>
  );
};
